/* eslint-disable */
// @ts-nocheck
import * as R from 'ramda';
import debugLib from 'debug';
import { reducerWrapper } from '../../main/support/utils';
import { LOADING_STATUS } from '../../main/support/constants';
import { APP_VIEW, APP_VIEW_ID_FIELD, ATTRIBUTION_SETTINGS_KEY } from '../support/viewConstants';
import type { App, AppReducer as AppReducerType } from '../types/appTypes';
import { SAVE_SK_AD_NETWORK_CONFIGURATION } from '../../main/actions/SKAdnetworkAction';
import { UPDATE_ORGANIC_SEARCH_DOMAINS } from '../../main/actions/Seo/SeoConfigurationActions';
import {
  APP_INITIALIZED,
  FETCH_CURRENT_APP,
  MOUNT_APP,
  FETCH_APPS,
  FETCH_TUNE_SITE_DATA,
  FETCH_APPS_PERMISSIONS,
  SAVE_APP_ATTRIBUTION_WINDOWS,
  UPDATE_APP,
  RESET_BRANCH_KEY,
  RESET_BRANCH_SECRET,
} from '../actions/AppActions';
const { view } = window.App.context;
const debug = debugLib('AppReducer');
export const INIT_STATE: AppReducerType = {
  apps: [],
  appsPermissions: [],
  app_id: view && view.current_view === APP_VIEW ? view[APP_VIEW_ID_FIELD] : null,
  currentApp: null,
  tuneSiteData: {
    siteIds: null,
    subdomains: null,
  },
  error: null,
  getAppById: function (app_id: string): App {
    const app = R.find(R.propEq('app_id', app_id), this.apps);
    return app || {};
  },
  getAppsByOrganizationId: function (organization_id: string): Array<App> {
    const apps = this.apps.filter(R.propEq('organization_id', organization_id));
    return apps || [];
  },
  loadingStatus: LOADING_STATUS.INIT,
  initializationComplete: false,
  userOnAppView: view && view.current_view === APP_VIEW,
};

function Handler(state: AppReducerType, action: Record<string, any>) {
  switch (action.type) {
    case APP_INITIALIZED:
      return { ...state, initializationComplete: true };

    case FETCH_CURRENT_APP.response:
      return { ...state, currentApp: action.data.app, loadingStatus: LOADING_STATUS.LOADED };

    case MOUNT_APP:
      const app = R.find(R.propEq('app_id', action.app_id), state.apps);

      if (!app) {
        return state;
      }

      return R.assoc('currentApp', app, state);

    case FETCH_APPS.response:
      debug(action);
      const apps = action.data;
      return {
        ...state,
        apps,
        currentApp: R.find(R.propEq('app_id', state.app_id), apps),
        loadingStatus: LOADING_STATUS.LOADED,
      };

    case FETCH_TUNE_SITE_DATA.response:
      debug(action);
      return { ...state, tuneSiteData: { ...action.data } };

    case SAVE_APP_ATTRIBUTION_WINDOWS.response:
      debug(action);
      const windows = action.data && action.data.windows;
      return {
        ...state,
        currentApp: { ...state.currentApp, [ATTRIBUTION_SETTINGS_KEY]: windows },
        error: null,
        loadingStatus: LOADING_STATUS.LOADED,
      };

    case UPDATE_ORGANIC_SEARCH_DOMAINS.response:
      return { ...state, currentApp: { ...state.currentApp, organic_search_domains: action.data.toString() || '' } };

    case UPDATE_APP.response:
    case RESET_BRANCH_KEY.response:
    case RESET_BRANCH_SECRET.response:
      return {
        ...state,
        loading: false,
        error: null,
        currentApp: { ...state.currentApp, ...action.data },
        loadingStatus: LOADING_STATUS.LOADED,
      };

    case FETCH_APPS_PERMISSIONS.response:
      const appsPermissions = action.data;
      return { ...state, appsPermissions };

    case SAVE_SK_AD_NETWORK_CONFIGURATION.response:
      return { ...state, currentApp: { ...state.currentApp, sk_ad_network_enabled: action.data.updatedSkAdNetworkEnabled } };

    default:
      return state;
  }
}

const AppReducer = reducerWrapper(INIT_STATE, Handler, {
  request: [FETCH_CURRENT_APP, FETCH_APPS, SAVE_APP_ATTRIBUTION_WINDOWS, UPDATE_ORGANIC_SEARCH_DOMAINS, UPDATE_APP],
  error: [FETCH_CURRENT_APP, FETCH_APPS, SAVE_APP_ATTRIBUTION_WINDOWS, UPDATE_ORGANIC_SEARCH_DOMAINS, UPDATE_APP],
  resetOn: ['APP_CHANGE'],
});
export default AppReducer;
